import { MDCMenu, Corner } from '@material/menu'
import { MDCList } from '@material/list'
import { MDCTextField } from '@material/textfield'
import { MDCDialog } from '@material/dialog'
import { MDCSelect } from '@material/select'
import { MDCCircularProgress } from '@material/circular-progress'
import * as moment from 'moment'

// EXIF
import { EXIF } from 'exif-js'

// timepicker
import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.min.css'

// FLATPICKER
window.flatpickr = flatpickr

// Moment
window.moment = moment

// EXIF
window.EXIF = EXIF
window.rotateExif = (toRotate, orientation, width, height) => {
  console.log('rotateExif', orientation, width, height )
  if (toRotate) {
  switch (orientation) {
    case 1:
      // 1 = 0 degrees: the correct orientation, no adjustment is required.
      break
    case 2:
      // 2 = 0 degrees, mirrored: image has been flipped back-to-front.
      toRotate.setTransform(-1, 0, 0, 1, width, 0)
      break
    case 3:
      // 3 = 180 degrees: image is upside down.
      toRotate.setTransform(-1, 0, 0, -1, width, height)
      break
    case 4:
      // 4 = 180 degrees, mirrored: image has been flipped back-to-front and is upside down.
      toRotate.setTransform(1, 0, 0, -1, 0, height)
      break
    case 5:
      // 5 = 90 degrees: image has been flipped back-to-front and is on its side.
      toRotate.setTransform(0, 1, 1, 0, 0, 0)
      break
    case 6:
      console.log('rotateExif.its6!', orientation, width, height )

      // 6 = 90 degrees, mirrored: image is on its side.
      // ctx.setTransform(0, 1, -1, 0, canvas.width, 0); // overwrite existing transform

      toRotate.setTransform(0, 1, -1, 0, width, 0)
      break
    case 7:
      // 7 = 270 degrees: image has been flipped back-to-front and is on its far side.
      toRotate.setTransform(0, -1, -1, 0, height, width)
      break
    case 8:
      // 8 = 270 degrees, mirrored: image is on its far side.
      // ctx.transform(0, -1, 1, 0, 0, height);
      toRotate.setTransform(0, -1, 1, 0, 0, width)
      break
    default:
      break
  }
  }
  return toRotate
}

window.mdc = {}

// DIALOG
window.mdc.MDCDialog = MDCDialog

// PROGRESS
document.querySelectorAll('.mdc-circular-progress').forEach(function (progCirc) {
  // eslint-disable-next-line no-unused-vars
  const circularProgress = new MDCCircularProgress(progCirc)
})

// SELECT
window.mdc.selects = []
document.querySelectorAll('.mdc-select').forEach(function (selEl) {
  // eslint-disable-next-line no-unused-vars
  const select = new MDCSelect(selEl)
  window.mdc.selects.push(select)
  select.listen('MDCSelect:change', () => {
    try {
      // eslint-disable-next-line no-undef
      if (selectChange) {
        // eslint-disable-next-line no-undef
        selectChange(select)
      }
    } catch {
      // no callback
    }
  })
})

const allTextFields = document.querySelectorAll('.mdc-text-field')
for (const textFieldEl of allTextFields) {
  // eslint-disable-next-line no-unused-vars
  const textfield = new MDCTextField(textFieldEl)
}

const menuEl = document.querySelector('.mdc-menu')
if (menuEl) {
  const menu = new MDCMenu(menuEl)
  menu.setAnchorCorner(Corner.BOTTOM_END)
  window.menuClick = function () {
    menu.open = true
  }
}

if (document.querySelector('.mdc-list')) {
  // eslint-disable-next-line no-unused-vars
  const list = new MDCList(document.querySelector('.mdc-list'))
}

// Firebase
const { firebaseConfig } = require('./firebaseConfig')

// eslint-disable-next-line no-undef
firebase.initializeApp(firebaseConfig)